module.exports = __webpack_public_path__ + "static/img/login_bg4.39b157d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/loginLuobei/img/login_bg4.jpg
// module id = ovMV
// module chunks = 183